export const ReceiptTypes = {
  SHOW_RECEIPT: "SHOW_RECEIPT",
};
